import type { ReactNode } from 'react';

import { BINARY_DECOMPOSITION } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import useRevision from '../../hooks/useRevision';

/**
 * Hides children if the current revision has partial results.
 */
const PartialResultGate = ({ children }: { children: ReactNode }) => {
  const revision = useRevision();
  const isBinaryDecompositionEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);

  const doesRevisionHavePartialResults =
    !revision.data?.isSteady &&
    revision.data?.dependency_count !== undefined &&
    revision.data.dependency_count > 0;

  if (doesRevisionHavePartialResults && isBinaryDecompositionEnabled) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default PartialResultGate;
